// Import packages
import React, {Component} from "react";
import {connect} from "react-redux";

// Import Styles
import '../../assets/styles/containerStyles/user-details.scss';

// Import components
import ItemsList from "../../components/ItemsList";
import PageWrapper from '../../components/pageContentViews/pageWrapper';
import ModalSendNotification from "../../components/uiElements/ModalSendNotification";
import {SkeletonSmallItem} from "../../components/uiElements/SkelatonISmalltem";
import {LinkButton} from "../../components/buttons/buttons";
import {CustomTabs} from "../../components/uiElements/Tabs";
import {Switch} from 'antd';


// Import utils
import {mapStateToProps} from "../../redux/mapStateToProps";
import { generateFileMediaUrl, generateUserImageMediaUrl } from "../../utils/generateMemberMediaUrl";
import {changeStateField, toggleStateField} from "../../utils/helperFunctions";
import {
    GetUserById,
    clearUserById,
    ToggleUserBlockState,
    GetOrders,
    GetReviews,
    SetOrderAsSeen,

} from "../../redux/actions";
import {userDetailsTabs} from "./utils/constants";
import {ordersDataParser, ordersListHeaderInfo} from "../../utils/listDataHelpers/order";
import {reviewListHeaderInfo, reviewsDataParser} from "../../utils/listDataHelpers/review";
import {bonusCardsHistoryHeaderInfo, parseBonusCardHistoryData} from "../../utils/listDataHelpers/history";
import { resizeImage } from "../../utils/resizeImage";

class UserDetails extends Component {
    constructor() {
        super();
        this.state = {
            isBlockedUpdated: false,
            notificationModalOpen: false,
            orders: {
                itemsList: [],
                hasMore: false
            },
            reviews: {
                itemsList: [],
                hasMore: false
            },
            history: {
                itemsList: [],
                hasMore: false
            },
            loading: true,
            activeTab: userDetailsTabs[0].key,
        };
        this.changeTab = changeStateField.bind(this, "activeTab");
        this.loadMoreOrders = this.loadMoreOrders.bind(this);
        this.loadMoreReviews = this.loadMoreReviews.bind(this);
        this.loadMoreHistory = this.loadMoreHistory.bind(this);
        this.toggleNotificationModal = toggleStateField.bind(this, "notificationModalOpen");
    }

    async componentDidMount() {
        const id = this.props.id;
        await this.props.GetUserById(id);
        try {
            const orders = await this.props.GetOrders({userId: id, getResponse: true});
            const reviews = await this.props.GetReviews({userId: id, getResponse: true});
            const history = {};
            Array.isArray(orders?.data) && this.setState({
                orders: {
                    itemsList: orders.data,
                    hasMore: orders.hasMore
                },
                loading: false
            });
            Array.isArray(reviews?.data) && this.setState({
                reviews: {
                    itemsList: reviews.data,
                    hasMore: reviews.hasMore
                },
            })
            Array.isArray(history?.data) && this.setState({
                history: {
                    itemsList: history.data,
                    hasMore: history.hasMore
                },
            })
        } catch {
            this.setState({loading: false})
        }
    }

    componentWillUnmount() {
        this.props.clearUserById();
    }

    async loadMoreOrders() {
        // console.log('load-more-orders')
        const {orders} = this.state;
        if (!this.fetchingOrders && orders.hasMore) {
            this.fetchingOrders = true;
            try {
                const newData = await this.props.GetOrders({
                    userId: this.props.id,
                    getResponse: true,
                    offset: orders.itemsList.length
                });
                Array.isArray(newData) && this.setState({
                    orders: {
                        itemsList: orders.itemsList.concat(newData.data),
                        hasMore: newData.hasMore
                    }
                })
                this.fetchingOrders = false
            } catch {
            }
        }
    };

    async loadMoreReviews() {
        // console.log('load-more-orders')
        const {reviews} = this.state;
        if (!this.fetchingReviews && reviews.hasMore) {
            this.fetchingReviews = true;
            try {
                const newData = await this.props.GetReviews({
                    userId: this.props.id,
                    getResponse: true,
                    offset: reviews.itemsList.length
                });
                Array.isArray(newData) && this.setState({
                    reviews: {
                        itemsList: reviews.itemsList.concat(newData.data),
                        hasMore: newData.hasMore
                    }
                })
                this.fetchingReviews = false
            } catch {
            }
        }
    };

    async loadMoreHistory() {
        // // console.log('load-more-orders')
        // const {history} = this.state;
        // if (!this.fetchingHistory && history.hasMore) {
        //     this.fetchingHistory = true;
        //     try {
        //         const newData = await this.props.GetUserHistory({
        //             userId: this.props.id,
        //             offset: history.itemsList.length
        //         });
        //         Array.isArray(newData) && this.setState({
        //             history: {
        //                 itemsList: history.itemsList.concat(newData.data),
        //                 hasMore: newData.hasMore
        //             }
        //         })
        //         this.fetchingHistory = false
        //     } catch {
        //     }
        // }
    };

    async upDateUser({value}) {
        const id = this.props.id;
        await this.setState({
            isBlockedUpdated: true,
        });
        const reqData = {isBlocked: value};
        this.props.ToggleUserBlockState(id, reqData).finally(() => {
            this.setState({
                isBlockedUpdated: false,
            });
        });
    }

    render() {
        const {isBlockedUpdated, userById, requestLoading} = this.props;
        const {notificationModalOpen, activeTab, orders, reviews, history, loading} = this.state;

        const headerData = {
            orders: ordersListHeaderInfo,
            reviews: reviewListHeaderInfo,
            history: bonusCardsHistoryHeaderInfo
        };
        const listData = {
            orders: ordersDataParser(orders),
            reviews: reviewsDataParser(reviews),
            history: parseBonusCardHistoryData(history),
        };
        const itemListHeaderInfo = headerData[activeTab];
        const itemListInfo = listData[activeTab];

        // const link = activeTab !== userDetailsTabs[2].key && activeTab + '/' + activeTab.slice(0, -1);
        const pageTitle = userById?.firstName ? `${userById?.firstName} ${userById?.lastName}` : ""
        return <PageWrapper pageTitle={pageTitle}>
            <section className="user-details">
                <div className="top-part">
                    <div className="user-image">
                        <img src={resizeImage(generateUserImageMediaUrl(userById?.profilePicturePath?.path))} alt="user"/>
                    </div>
                    <div className="user-info">
                        <span className="username">{
                            requestLoading ?
                                <SkeletonSmallItem/> : `${userById?.firstName} ${userById?.lastName}`
                        }
                        </span>
                        <div>{
                            requestLoading ?
                                <SkeletonSmallItem/> : `${userById?.username}`
                        }</div>
                        <div>{
                            requestLoading ?
                                <SkeletonSmallItem/> : `${userById?.region?.title}, ${userById?.region?.residence?.title}`
                        }</div>
                    </div>
                    <div className={'block-wrapper'}>
                        <label>Blocked</label>
                        <Switch checked={userById?.isBlocked} loading={isBlockedUpdated}
                                onChange={(checked) => this.upDateUser({
                                    name: "isBlocked",
                                    value: checked,
                                })}/>
                    </div>
                </div>
                {/*<div className={'send-notif'}>
                    <LinkButton title={"Ծանուցում"}
                                cb={this.toggleNotificationModal}/>
                </div>*/}
                <CustomTabs tabsList={userDetailsTabs} activeTab={activeTab} changeTab={this.changeTab}/>

                <ItemsList itemListInfo={itemListInfo}
                           itemListHeaderInfo={itemListHeaderInfo}
                           // detailsLink={link}
                           // editLink={link}
                           loading={loading}
                           className={`user-details-list ${activeTab}-list`}
                           infiniteScroll={true}
                           hasMore={this.state[activeTab]?.hasMore}
                           loadMoreItems={this['loadMore' + activeTab]}/>
            </section>
            <ModalSendNotification visible={notificationModalOpen}
                                   userIds={[this.props.id]}
                                   closeModal={this.toggleNotificationModal}/>
        </PageWrapper>
    }
}

const mapDispatchToProps = {
    GetUserById,
    GetOrders,
    GetReviews,
    clearUserById,
    SetOrderAsSeen,
    ToggleUserBlockState
};

export default connect(mapStateToProps, mapDispatchToProps)(UserDetails)
